/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function Table2({ setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      taxpayers: "",
      taxCode: "",
      number: "",
      day: "",
      money: "",
      dayPayment: "",
      taxPrice: "",
      vatPayable: "",
      taxableIncome: "",
      citpayable: "",
      totalTax: "",
    },
  ]);
  const [data2, setData2] = useState([
    {
      id: uuidV4(),
      taxpayers: "",
      taxCode: "",
      identifier: "",
      number: "",
      day: "",
      money: "",
      dayPayment: "",
      taxPrice: "",
      vatPayable: "",
      taxableIncome: "",
      citpayable: "",
      totalTax: "",
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);
  useEffect(() => {
    setFieldValue("valuesTable2", data2);
  }, [data2]);
  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChange2 = (values) => {
    const { id, name, value, type } = values;
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeDate2 = (date, id) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleChangeSelect2 = (id, name, value) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        taxpayers: "",
        taxCode: "",
        number: "",
        day: "",
        money: "",
        dayPayment: "",
        taxPrice: "",
        vatPayable: "",
        taxableIncome: "",
        citpayable: "",
        totalTax: "",
      },
    ]);
  };
  const handleAdd2 = () => {
    setData2((prev) => [
      ...prev,
      {
        id: uuidV4(),
        taxpayers: "",
        taxCode: "",
        identifier: "",
        number: "",
        day: "",
        money: "",
        dayPayment: "",
        taxPrice: "",
        vatPayable: "",
        taxableIncome: "",
        citpayable: "",
        totalTax: "",
      },
    ]);
  };
  const handleChangeValue = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleChangeValue2 = (id, name, value) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };
  const handleDelete2 = (id) => {
    setData2((prev) => prev.filter((item) => item.id !== id));
  };
  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="subtitle1" fontSize={14} fontWeight={"bold"}>
        I. Kê khai thay cho người nộp thuế có tài sản đảm bảo là tổ chức, doanh nghiệp
      </Typography>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", maxWidth: 10, fontWeight: "bold" }}
              >
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Người nộp thuế có tài sản bảo đảm
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 300, fontWeight: "bold" }}>
                Mã số thuế
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Hợp đồng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Số tiền thanh toán trong kỳ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Ngày thanh toán
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế GTGT
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế TNDN
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Tổng số thuế phải nộp
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", minWidth: 100, fontWeight: "bold" }}>Số</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Ngày/tháng/năm</Td>
              <Td style={{ textAlign: "center", minWidth: 200, fontWeight: "bold" }}>
                Giá tính thuế
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Thuế GTGT phải nộp</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Thu nhập tính thuế</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Thuế TNDN phải nộp</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(1)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(2)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(3)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(4)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(5)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(6)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(7)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(8)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(9)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(10)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(11)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(12)=(9)+(11)</Td>
            </tr>

            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxpayers"
                    value={item.taxpayers}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxCode"
                    value={item.taxCode}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="number"
                    value={item.number}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="day"
                    onChange={(e) => handleChangeValue(item.id, "day", e[0])}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="money"
                    value={item.money}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="dayPayment"
                    onChange={(e) => handleChangeValue(item.id, "dayPayment", e[0])}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxPrice"
                    value={item.taxPrice}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="vatPayable"
                    value={item.vatPayable}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxableIncome"
                    value={item.taxableIncome}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="citpayable"
                    value={item.citpayable}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="totalTax"
                    value={item.totalTax}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
            {/*  */}
            <tr>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                Cộng
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  // id={item.id}
                  name="taxPrice"
                  value={0}
                  style={{
                    background: "#ddeff3",
                    border: 0,
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                  // onChange={handleChange}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  // id={item.id}
                  name="vatPayable"
                  value={0}
                  style={{
                    background: "#ddeff3",
                    border: 0,
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                  // onChange={handleChange}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  // id={item.id}
                  name="taxableIncome"
                  value={0}
                  style={{
                    background: "#ddeff3",
                    border: 0,
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                  // onChange={handleChange}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  // id={item.id}
                  name="citpayable"
                  value={0}
                  style={{
                    background: "#ddeff3",
                    border: 0,
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                  // onChange={handleChange}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  // id={item.id}
                  name="totalTax"
                  value={0}
                  style={{
                    background: "#ddeff3",
                    border: 0,
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                  // onChange={handleChange}
                />
              </Td>
            </tr>
            <SoftBox
              display="flex"
              width={150}
              marginBottom={2}
              justifyContent="flex-start"
              gap={3}
              mt={2}
            >
              <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
                Thêm dòng
              </SoftButton>
            </SoftBox>
          </tbody>
        </table>
      </Box>
      {/*  */}
      <Typography variant="subtitle1" fontSize={14} fontWeight={"bold"}>
        II. Kê khai thay cho người nộp thuế có tài sản đảm bảo là cá nhân
      </Typography>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", maxWidth: 10, fontWeight: "bold" }}
              >
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Người nộp thuế có tài sản bảo đảm
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 300, fontWeight: "bold" }}>
                Mã số thuế
              </Td>
              <Td
                rowSpan={2}
                style={{ textAlign: "center", minWidth: 300, minWidth: 300, fontWeight: "bold" }}
              >
                CMND/Thẻ CCCD (đối với NNT không có thông tin MST)
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Hợp đồng
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Số tiền thanh toán trong kỳ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Ngày thanh toán
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế GTGT
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế TNDN
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Tổng số thuế phải nộp
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", minWidth: 100, fontWeight: "bold" }}>Số</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Ngày/tháng/năm</Td>
              <Td style={{ textAlign: "center", minWidth: 200, fontWeight: "bold" }}>
                Giá tính thuế
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Thuế GTGT phải nộp</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Thu nhập tính thuế</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Thuế TNDN phải nộp</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(1)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(2)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(3)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(4)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(5)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(6)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(7)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(8)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(9)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(10)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(11)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(12)</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>(13)=(10)+(12)</Td>
            </tr>

            {data2.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete2(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxpayers"
                    value={item.taxpayers}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxCode"
                    value={item.taxCode}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="identifier"
                    value={item.identifier}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="number"
                    value={item.number}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="day"
                    onChange={(e) => handleChangeValue2(item.id, "day", e[0])}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="money"
                    value={item.money}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <DatePicker
                    style={selectStyle}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="dayPayment"
                    onChange={(e) => handleChangeValue2(item.id, "dayPayment", e[0])}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxPrice"
                    value={item.taxPrice}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="vatPayable"
                    value={item.vatPayable}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxableIncome"
                    value={item.taxableIncome}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="citpayable"
                    value={item.citpayable}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="totalTax"
                    value={item.totalTax}
                    onChange={handleChange2}
                  />
                </Td>
              </tr>
            ))}
            {/*  */}
            <tr>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                Cộng
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  // id={item.id}
                  name="taxPrice"
                  value={0}
                  style={{
                    background: "#ddeff3",
                    border: 0,
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                  // onChange={handleChange}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  // id={item.id}
                  name="vatPayable"
                  value={0}
                  style={{
                    background: "#ddeff3",
                    border: 0,
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                  // onChange={handleChange}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  // id={item.id}
                  name="taxableIncome"
                  value={0}
                  style={{
                    background: "#ddeff3",
                    border: 0,
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                  // onChange={handleChange}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  // id={item.id}
                  name="citpayable"
                  value={0}
                  style={{
                    background: "#ddeff3",
                    border: 0,
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                  // onChange={handleChange}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  // id={item.id}
                  name="totalTax"
                  value={0}
                  style={{
                    background: "#ddeff3",
                    border: 0,
                    textAlign: "right",
                    fontWeight: "bold",
                  }}
                  // onChange={handleChange}
                />
              </Td>
            </tr>
            <SoftBox
              display="flex"
              width={150}
              marginBottom={2}
              justifyContent="flex-start"
              gap={3}
              mt={2}
            >
              <SoftButton variant="gradient" color="dark" onClick={handleAdd2}>
                Thêm dòng
              </SoftButton>
            </SoftBox>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
